export enum Languages {
  EN = 'en',
  DE = 'de',
}

export type TSupportedLanguage = {
  code: Languages;
  label: string;
  isDefault?: boolean;
};

export const SUPPORTED_LANGUAGES: TSupportedLanguage[] = [
  { code: Languages.EN, label: 'English' },
  { code: Languages.DE, label: 'Deutsch', isDefault: true },
];
